<div class="counter-container d-flex flex-row align-items-center" [ngClass]="{ 'warning': inLastMinutesOfNextEvent(), 'urgent': inLastMinuteOfNextEvent() }" *ngIf="visible">
  <nb-icon *ngIf="isAuctionActive()" icon="clock-outline"></nb-icon>
  <div class="ml-1 ml-sm-3">
    <div class="info-text">{{ timeRemainingMessage.status }}</div>
    <div class="counter-time-counter">{{ timeRemainingMessage.timeRemaining }}</div>
  </div>
</div>
